<template>
  <AppLayout>
    <div class="content">
      <img alt="Hellocare" src="../../assets/images/signup-success.png">
      <p class="text">
        Votre mot de passe a bien été modifié. Vous pouvez maintenant accéder à votre cabinet connecté Hellocare.
      </p>
      <div class="center">
        <ButtonGreen :link-to="{ name: 'login' }">Continuer</ButtonGreen>
      </div>
    </div>
  </AppLayout>
</template>

<script>
  import AppLayout from '@/components/AppLayout.vue';
  import ButtonGreen from '@/components/ButtonGreen.vue';

  export default {
    name: 'ForgottenPasswordStep4Page',
    components: { ButtonGreen, AppLayout },
  };
</script>

<style lang="scss" scoped>
  img {
    display: block;
    width: 100px;
    margin: 0 auto 3rem;
  }

  .text {
    font-weight: 500;
    text-align: center;
    font-size: 3rem;
  }

  .center {
    text-align: center;
  }
</style>
